import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import * as Highcharts from "highcharts";

@Component({
  selector: "app-analysis-appointments",
  templateUrl: "./analysis-appointments.component.html",
  styleUrls: ["./analysis-appointments.component.scss"],
})
export class AnalysisAppointmentsComponent implements OnInit {
  allappointment = {
    schedapppercent: 0,
    icapppercent: 0,
    totalpercent: 0,
    todayCount: 0,
    tomorrowCount: 0,
    currentWeekCount: 0,
    lastWeekCount: 0,
    currentMonthCount: 0,
    currentYearCount: 0,
    lastYearCount: 0,
    lastQuarterCount: 0,
  };
  schedappointment: any = {
    todaySchedCount: 0,
    tomorrowSchedCount: 0,
    currentWeekSchedCount: 0,
    lastWeekSchedCount: 0,
    currentMonthSchedCount: 0,
    currentYearSchedCount: 0,
    lastYearSchedCount: 0,
    lastQuarterSchedCount: 0,
  };
  icappointment = {
    todayICCount: 0,
    tomorrowICCount: 0,
    currentWeekICCount: 0,
    lastWeekICCount: 0,
    currentMonthICCount: 0,
    currentYearICCount: 0,
    lastYearICCount: 0,
    lastQuarterICCount: 0,
  };
  schedapppercent: any;
  icapppercent: any;
  typeinit: any = "all";
  examscheddata = [];
  examicdata = [];
  newdate: any;
  totalschedcount = 0;
  totaliccount = 0;
  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}

  successMessage: any = "";
  errorMessage: any = "";

  ngOnInit() {
    const date = new Date();
    this.newdate =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      "00:00:00";
    this.getallappointments("");
  }

  getallappointments(type) {
    if (type) {
      this.typeinit = type;
    } else {
      this.typeinit = "all";
    }

    if (this.typeinit === "all") {
      const data = {
        tcid: localStorage.getItem("testCenterId"),
        type: this.typeinit,
        date: this.newdate,
      };
      this.appService.getallappointments(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            if (res["entity"]) {
              this.allappointment = res["entity"];
              this.allappointment.schedapppercent = Math.round(
                (res["entity"].schedAppCount / res["entity"].totalCount) * 100
              );
              this.allappointment.icapppercent = Math.round(
                (res["entity"].icAppCount / res["entity"].totalCount) * 100
              );
              this.allappointment.totalpercent =
                this.allappointment.schedapppercent +
                this.allappointment.icapppercent;

              this.piechart(
                this.allappointment.schedapppercent,
                this.allappointment.icapppercent,
                this.allappointment.totalpercent
              );
            }
          } else {
            this.allappointment = {
              schedapppercent: 0,
              icapppercent: 0,
              totalpercent: 0,
              todayCount: 0,
              tomorrowCount: 0,
              currentWeekCount: 0,
              lastWeekCount: 0,
              currentMonthCount: 0,
              currentYearCount: 0,
              lastYearCount: 0,
              lastQuarterCount: 0,
            };
          }
        },
        (err) => {
          this.appService.sessionOut(err);
        }
      );
    } else if (this.typeinit == "sched") {
      this.getallexamcount(this.typeinit);
      const data1 = {
        tcid: localStorage.getItem("testCenterId"),
        type: this.typeinit,
        date: this.newdate,
      };
      this.appService.getallappointments(data1).subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.schedappointment = res["entity"];
          }
        } else {
          this.schedappointment = {
            todaySchedCount: 0,
            tomorrowSchedCount: 0,
            currentWeekSchedCount: 0,
            lastWeekSchedCount: 0,
            currentMonthSchedCount: 0,
            currentYearSchedCount: 0,
            lastYearSchedCount: 0,
            lastQuarterSchedCount: 0,
          };
        }
      });
    } else if (this.typeinit === "ic") {
      this.getallexamcount(this.typeinit);
      const data2 = {
        tcid: localStorage.getItem("testCenterId"),
        type: this.typeinit,
        date: this.newdate,
      };
      this.appService.getallappointments(data2).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            if (res["entity"]) {
              this.icappointment = res["entity"];
            }
          } else {
            this.icappointment = {
              todayICCount: 0,
              tomorrowICCount: 0,
              currentWeekICCount: 0,
              lastWeekICCount: 0,
              currentMonthICCount: 0,
              currentYearICCount: 0,
              lastYearICCount: 0,
              lastQuarterICCount: 0,
            };
          }
        },
        (err) => {
          this.appService.sessionOut(err);
        }
      );
    }
  }

  piechart(schedcount, iccount, totalcount) {
    Highcharts.chart("container", {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "<br>Appointments<br>" + totalcount + "%",
        align: "center",
        verticalAlign: "middle",
        // y: 100
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          colors: ["#A3A0FBEB", "#FF8373EB"],
          dataLabels: {
            enabled: true,
            distance: -50,
            style: {
              fontWeight: "bold",
              fontSize: "15px",
              color: "white",
            },
            format: " {point.percentage} %",
          },
          startAngle: -360,
          endAngle: 360,
          size: "110%",
        },
      },
      series: [
        {
          type: "pie",
          innerSize: "50%",
          data: [
            {
              name: schedcount > 0 ? schedcount : "",
              y: schedcount > 0 ? schedcount : 0,
            },
            {
              name: iccount > 0 ? iccount : "",
              y: iccount > 0 ? iccount : 0,
            },
          ],
        },
      ],
    });
  }

  getallexamcount(typevalue) {
    if (typevalue === "sched") {
      const data = {
        tcid: localStorage.getItem("testCenterId"),
        type: typevalue,
      };
      this.appService.getallexamcount(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            if (res["entity"]) {
              this.examscheddata = res["entity"];
              this.totalschedcount = 0;
              for (let index = 0; index < this.examscheddata.length; index++) {
                this.totalschedcount += +this.examscheddata[index].examCount;
              }
            }
          }
        },
        (err) => {
          this.appService.sessionOut(err);
        }
      );
    } else if (typevalue === "ic") {
      const data3 = {
        tcid: localStorage.getItem("testCenterId"),
        type: typevalue,
      };
      this.appService.getallexamcount(data3).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            if (res["entity"]) {
              this.examicdata = res["entity"];
              this.totaliccount = 0;
              for (let index = 0; index < this.examicdata.length; index++) {
                this.totaliccount += +this.examicdata[index].examCount;
              }
            }
          }
        },
        (err) => {
          this.appService.sessionOut(err);
        }
      );
    }
  }
}
